import React, { Component } from 'react';
import {
  BrowserRouter as Router,
} from 'react-router-dom'
import { 
  Switch,
  Route,
} from 'react-router'
import Home from './views/Home';
import Error404 from './views/Error404';
import {
  firebaseDb,
  firebaseAuth,
} from './lib/firebase/firebase';

class AppNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentWillMount(){
  }
  componentDidMount(){
  }
  render() {
    return (
      <Router>
        <Switch>
            <Route exact path="/" render={
              function(){
                if(this.props.user.is_admin){
                  return (
                    <Home
                      user={this.props.user} />
                  );
                }else{
                  return (<Error404 />)
                }
              }.bind(this)} />
            <Route render={
              ()=>(
                <Error404 />
              )} />
        </Switch>
      </Router>
    );
  }
}

export default AppNav;



// WEBPACK FOOTER //
// ./src/AppNav.js